import { render, staticRenderFns } from "./show.vue?vue&type=template&id=8f82b21a&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f82b21a')) {
      api.createRecord('8f82b21a', component.options)
    } else {
      api.reload('8f82b21a', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=8f82b21a&", function () {
      api.rerender('8f82b21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/receipt/show.vue"
export default component.exports